import { sourceDataSchema, type AssetSourceData } from './assetSourceTypes.ts'

function normalizeUrlString(input: string) {
  try {
    const url = new URL(input)
    const params = new URLSearchParams(url.search)
    const sortedKeys = Array.from(params.keys()).sort()

    const sortedParams = new URLSearchParams()
    for (const key of sortedKeys) {
      const values = params.getAll(key)
      values.sort()
      for (const value of values) {
        sortedParams.append(key, value)
      }
    }

    const pathname = url.pathname.replace(/\/+$/g, '') || '/'

    const normalized = `${url.protocol.toLowerCase()}//${url.host.toLowerCase()}${pathname}${sortedParams.toString() ? `?${sortedParams.toString()}` : ''}`
    return normalized
  } catch {
    return String(input || '').trim()
  }
}

function djb2(input: string) {
  let hash = 5381
  for (let index = 0; index < input.length; index++) {
    const charCode = input.charCodeAt(index)
    hash = ((hash << 5) + hash) ^ charCode
  }
  const result = (hash >>> 0).toString(16)
  return result
}

export function normalizeSourceData(input: unknown): AssetSourceData {
  const parsed = sourceDataSchema.parse(input)

  const normalizedWebUrl = parsed.sourceWebUrl ? normalizeUrlString(parsed.sourceWebUrl) : undefined

  const normalizedDocumentUrl = parsed.sourceDocumentUrl
    ? String(parsed.sourceDocumentUrl).trim()
    : undefined

  return {
    sourceWebUrl: normalizedWebUrl,
    sourceDocumentUrl: normalizedDocumentUrl,
    runs: parsed.runs,
  }
}

export function sourceFingerprint(source: AssetSourceData) {
  const normalized = normalizeSourceData(source)
  const key = normalized.sourceWebUrl || normalized.sourceDocumentUrl || ''

  if (!key) {
    return 'none'
  }

  return djb2(key)
}

export function sourcesEqual(a: AssetSourceData, b: AssetSourceData) {
  const na = normalizeSourceData(a)
  const nb = normalizeSourceData(b)
  return (
    (na.sourceWebUrl || '') === (nb.sourceWebUrl || '') &&
    (na.sourceDocumentUrl || '') === (nb.sourceDocumentUrl || '')
  )
}
